import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'hk-emergency-contact',
  templateUrl: 'emergency-contact.component.html',
  host: { class: 'flex flex-1 flex-col ' },
})
export class EmergencyContactComponent {
  phoneNumber = '+49 7824 302-7722';
  supportedLanguages = 'German, English';
}
